import React, {createContext, useMemo, useRef} from 'react';

export const SlideRefContext = createContext<{
    slideRef: React.RefObject<HTMLDivElement>;
    slideWrapperRef: React.RefObject<HTMLDivElement>;
}>({
    slideRef: {current: null},
    slideWrapperRef: {current: null},
});

function SlideRefContextProvider({children}: {children: JSX.Element}): JSX.Element {
    const slideRef = useRef(null);
    const slideWrapperRef = useRef(null);

    const slideRefValue = useMemo(() => ({slideRef, slideWrapperRef}), [slideRef, slideWrapperRef]);

    return <SlideRefContext.Provider value={slideRefValue}>{children}</SlideRefContext.Provider>;
}

export default SlideRefContextProvider;
